import * as React from "react";
import { forwardRef } from "react";
const SvgGroupLayers = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} viewBox="0 0 25 25" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} transform="translate(1 1)"><path d="M6 17H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1h15c.552 0 1 .448 1 1v5" /><rect width={17} height={17} x={6} y={6} rx={1} /></g></svg>;
const ForwardRef = forwardRef(SvgGroupLayers);
export { ForwardRef as ReactComponent };